//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acSuppTrans', {
//        templateUrl: 'views/components/views/acSuppTrans/acSuppTrans.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'acSuppTransService', 'ttGridFactory', function ($stateParams, stateService, translateService, modalService, acSuppTransService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let acSuppTransKeyno = $stateParams.acsupptrans_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                removing: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_acsupptrans_match_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setOptionFunc((data) => optionFunc(data.data));

//            function optionFunc(data) {
//                if (data.func && data.func === 'CheckboxBoxClick') {
//                    if (data.dataItem.is_selected === true) {
//                        data.dataItem.is_selected_amount_locval_balance = data.dataItem.amount_locval;
//                    } else {
//                        data.dataItem.is_selected_amount_locval_balance = 0;
//                    }

//                    vm.grid.gridfunc.refresh();
//                    vm.grid.gridfunc.refreshAggregates();
//                } else if (data.func && data.func === 'CheckboxHeaderClick') {
//                    data.data.forEach((dataItem) => {
//                        if (dataItem.is_selected === true) {
//                            dataItem.is_selected_amount_locval_balance = dataItem.amount_locval;
//                        } else {
//                            dataItem.is_selected_amount_locval_balance = 0;
//                        }
//                    });

//                    vm.grid.gridfunc.refresh();
//                    vm.grid.gridfunc.refreshAggregates();
//                }
//            }

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await acSuppTransService.getAcSuppTrans({ acsupptrans_keyno: acSuppTransKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2829,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON REMOVE MATCHING PROCEDURE FUNCTION CALL

//            vm.removeChanges = function () {
//                vm.model.removing = true;

//                let dirtyRows = vm.grid.gridfunc.getDirtyRows();
//                let selectedItems = [];

//                dirtyRows.forEach((item) => {
//                    if (item.is_selected === '0' || item.is_selected === false) return;

//                    selectedItems.push({ acsupptransmatch_keyno: item.acsupptransmatch_keyno });
//                });

//                let mergeObj = angular.copy(vm.model.setting);
//                mergeObj.records = selectedItems;

//                acSuppTransService.removeMatchingSelected(mergeObj).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.removing = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.removing = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON REMOVE MATCHING PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
